import PropTypes from 'prop-types';

import { Wrapper } from './index.styles';

/**
 * Renders a container. Handles alignment, spacing, and wrapping.
 */
export default function Container({
  align = 'normal',
  children,
  className,
  direction = 'column',
  gap = 24,
  wrap,
}) {
  return (
    <Wrapper align={align} className={className} direction={direction} gap={gap} wrap={wrap}>
      {children}
    </Wrapper>
  );
}

Container.propTypes = {
  /**
   * Container align.
   */
  align: PropTypes.oneOf([
    'center',
    'flex-end',
    'flex-start',
    'normal',
    'space-around ',
    'space-between',
    'space-evenly',
  ]),
  /**
   * Container content.
   */
  children: PropTypes.node,
  /**
   * Container class name.
   */
  className: PropTypes.string,
  /**
   * Container direction.
   */
  direction: PropTypes.oneOf(['column', 'column-reverse', 'row', 'row-reverse']),
  /**
   * Container gap.
   */
  gap: PropTypes.number,
  /**
   * Whether to wrap container content.
   */
  wrap: PropTypes.bool,
};
